/** @file Handles the forgot password form for new login and registration. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as form from '@/components/Form';
import { getErrorMessage } from '@/utils';
import { clsInput } from './cls';
/** Form for requesting a password reset link by entering a username. */
export const ForgotPasswordForm = tsx.component({
    name: 'forgot-password-form',
    props: {
        submit: p.ofType().required,
    },
    /** @returns State of the component. */
    data() {
        return {
            username: '',
        };
    },
    computed: {
        /** @returns The reason why the submit button is disabled, or `undefined` if it is not disabled. */
        submitDisabledReason() {
            if (this.username.length === 0) {
                return { type: 'tooltip', reason: 'Please enter your username' };
            }
            return undefined;
        },
    },
    /** @returns The rendered forgot password form JSX. */
    render() {
        return (<form.Root data-cy="forgot-password-form" handleSubmit={async () => await this.submit(this.username)} submitLoadingMessage="Sending reset link" submitSuccessMessage="Reset link sent" submitLabel="Send reset link" submitDisabledReason={this.submitDisabledReason} submitOnEnter actionBarVariant="wide-submit" scopedSlots={{
                formError: err => getErrorMessage(err),
            }}>
                <form.Field label="Username" description="Enter your username to reset your password">
                    <form.Input class={clsInput} type="text" name="username" autocomplete="username" value={this.username} onInput={val => {
                this.username = val;
            }}/>
                </form.Field>
            </form.Root>);
    },
});
